/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Abweichendeschuleresolved2Inputs */

const de__field_abweichendeschuleresolved2 = /** @type {(inputs: _Field_Abweichendeschuleresolved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abweichende Schule`)
};

/**

* @param {_Field_Abweichendeschuleresolved2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_abweichendeschuleresolved2 = /** @type {((inputs?: _Field_Abweichendeschuleresolved2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Abweichendeschuleresolved2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_abweichendeschuleresolved2(inputs)
});
export { _field_abweichendeschuleresolved2 as "_field_abweichendeSchuleResolved" }